// Local translations
export const T = {
  en_GB: {
    name: "Name",
    description: "Description",
    language: "Language",
    selectLanguage: "Select language",
    languageCannotBeChanged: "Language cannot be changed after creation",
    noFlowsForLanguage: "No flows available for this language",
    flow: "Flow",
    cancel: "Cancel",
    createPdfTemplateTitle: "Create PDF Template",
    createDialogDescription:
      "Create a new PDF template. You'll configure the template structure in the editor.",
    namePlaceholder: "Client Investment Report",
    descriptionPlaceholder: "A comprehensive report for client portfolios",
    selectFlow: "Select a flow",
    pleaseSelectFlow: "Please select a flow",
    create: "Create",
    failedToCreate: "Failed to create PDF template",
  },
  nb_NO: {
    name: "Navn",
    description: "Beskrivelse",
    language: "Språk",
    selectLanguage: "Velg språk",
    languageCannotBeChanged: "Språk kan ikke endres etter opprettelse",
    noFlowsForLanguage: "Ingen flyter tilgjengelig for dette språket",
    flow: "Flyt",
    cancel: "Avbryt",
    createPdfTemplateTitle: "Opprett PDF-mal",
    createDialogDescription: "Opprett en ny PDF-mal. Du konfigurerer malstrukturen i editoren.",
    namePlaceholder: "Kundeinvesteringsrapport",
    descriptionPlaceholder: "En omfattende rapport for kundeporteføljer",
    selectFlow: "Velg en flyt",
    pleaseSelectFlow: "Vennligst velg en flyt",
    create: "Opprett",
    failedToCreate: "Kunne ikke opprette PDF-mal",
  },
} as const;
